var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"base-demo"},[_c('vue-table-dynamic',{attrs:{"params":_vm.params},on:{"row-click":_vm.rowClicked}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }